import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { listNumberRowTable } from 'utils/settings.js';
import { Text, ButtonWithDropdown } from '../Elements';

import classes from './LimitPaginationButton.module.scss';

const LimitPaginationButton = ({
  currentLimit,
  onLimitChange,
  listItems = listNumberRowTable
}) => {
  const { t } = useTranslation(['activity']);

  const handleItem = value => {
    onLimitChange(value);
  };

  return (
    <ButtonWithDropdown
      tooltipText={t('activity:buttons.QUANTITY_OF_ITEMS')}
      placement="top-end"
      icon="rowSize"
    >
      <ul className={classes.listWrap}>
        {listItems.map((item, index) => (
          <li
            key={index}
            className={classes.itemWrap}
            onClick={() => handleItem(item)}
          >
            <Text
              size={4}
              type={'p'}
              className={cn(
                classes.item,
                item === currentLimit && classes.item_change
              )}
            >
              {item}
            </Text>
          </li>
        ))}
      </ul>
    </ButtonWithDropdown>
  );
};

LimitPaginationButton.propTypes = {
  currentLimit: PropTypes.number.isRequired,
  onLimitChange: PropTypes.func.isRequired,
  listItems: PropTypes.arrayOf(PropTypes.number.isRequired)
};

export default LimitPaginationButton;
